var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-top":"20px"}},[_c('ExpandAllAccordion',{attrs:{"data":_vm.accordions,"header":"Errors"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }